var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ol',{staticClass:"ct-entry-data-summary-highlights"},_vm._l((_vm.highlights),function(highlight,index){return _c(_setup.CardDataSummaryHighlight,_vm._b({key:`CardHighlight${index}`},'CardDataSummaryHighlight',{
        highlight,
        translations: _setup.highlightsTranslation,
        index
    },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }